<template>
  <div class="advert-fullscreen">
    <h1>This is an advert</h1>
    <h1>Buy these things</h1>
    <button @click.stop="$emit('advert_finished')">Finish advert</button>
  </div>
</template>

<script>
export default {
  name: 'AdvertPlaceholder',
}
</script>

<style scoped>
.advert-fullscreen {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: white;
  color: grey;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
